const dateRegex = /^(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])-(20[0-9]{2}|2[1-9][0-9]{3}|[3-9][0-9]{3})$/;

export const validateDate = (dateString: string): boolean => {
  return dateRegex.test(dateString);
};
